module.exports = __webpack_public_path__ + "media/images/flags/16/Cape-Verde-43962dff4da715f1a5c3bdbb4531e83a.png";